import { Component, inject, Signal, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BadgeComponent,
  ButtonComponent,
  FormFieldComponent,
  IconComponent,
} from '@pansa/ui';
import { MessageService } from '../../services/message.service';
import { FilterSortService } from '@app/shared/services/filter-sort.service';
import { MessageDTO } from '../../models/message.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { SortState } from '@app/shared/models/sort.model';
import { MessageDatePipe } from '@app/shared/pipes/message-date.pipe';
import { MessageContentComponent } from '../message-content/message-content.component';
import { TruncatePipe } from '@app/shared/pipes/truncate.pipe';
import { MessagePanelService } from '../../services/message-panel.service';
import { MessageCreateComponent } from '../message-create/message-create.component';

@Component({
  selector: 'rqa-message-list',
  templateUrl: './message-list.component.html',
  styleUrl: './message-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    IconComponent,
    BadgeComponent,
    FormFieldComponent,
    MessageDatePipe,
    MessageContentComponent,
    MessageCreateComponent,
    TruncatePipe
  ]
})
export class MessageListComponent {
  private messageService = inject(MessageService);
  private filterService = inject<FilterSortService<MessageDTO>>(FilterSortService);
  private messagePanelService = inject(MessagePanelService);

  selectedMessage = signal<MessageDTO | null>(null);
  messagesSignal = toSignal(this.messageService.getMessages(), { initialValue: [] });
  filteredMessages!: Signal<MessageDTO[]>;

  filtersForm = new FormGroup({
    global: new FormControl('')
  });

  readonly sort = signal<SortState>({
    key: '',
    direction: ''
  });

  constructor() {
    const filtersSignal = toSignal(this.filtersForm.valueChanges, {
      initialValue: this.filtersForm.value
    });

    this.filteredMessages = this.filterService.connect({
      data: this.messagesSignal,
      filters: filtersSignal,
      sort: this.sort
    });
  }

  onTabChange(): void {}

  onShowMessage(message: MessageDTO): void {
    this.selectedMessage.set(message);
  }

  onCreateMessage(): void {
    this.messagePanelService.open();
  }
}
